import React from "react";

const StoreLocationMap = () => {
  const storeAddress =
    "151 O'Connor Street, Ground floor, Ottawa, ON, K2P 2L8";

  const handleGetDirection = () => {
    const encodedAddress = encodeURIComponent(storeAddress);
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    window.open(googleMapsUrl, "_blank");
  };

  return (
    <section
      style={{
        position: "relative",
        width: "100%",
        height: "580px",
        overflow: "hidden",
        margin: "0 0 60px 0",
        padding: "0 40px",
      }}
    >
      {/* Map Image */}
      <img
        src="https://wonder-theme-beauty.myshopify.com/cdn/shop/files/map-desktop.jpg?v=1740942817&width=3000"
        alt="Store Location Map"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "24px",
        }}
      />

      {/* Store Info Card */}
      <div
        style={{
          position: "absolute",
          top: "40px",
          left: "40px",
          width: "400px",
          padding: "32px 38px",
          borderRadius: "22px",
          background:
            "linear-gradient(180deg, rgba(255,255,255,0.85), rgba(255,255,255,0.65))",
          backdropFilter: "blur(16px)",
          WebkitBackdropFilter: "blur(16px)",
          border: "1px solid rgba(255,255,255,0.45)",
          boxShadow: "0 18px 35px rgba(0,0,0,0.12)",
          zIndex: 10,
        }}
      >
        <h2
          style={{
            fontSize: "30px",
            fontWeight: "400",
            marginBottom: "14px",
            color: "#000",
            fontFamily: "Merriweather, serif",
            lineHeight: "1.2",
          }}
        >
          Our Store
        </h2>

        <p
          style={{
            fontSize: "17px",
            fontFamily: "Figtree, sans-serif",
            color: "#222",
            lineHeight: "1.7",
            marginBottom: "28px",
          }}
        >
          151 O&apos;Connor Street, Ground floor,
          <br />
          Ottawa, ON, K2P 2L8.
        </p>

        {/* Button with onClick handler */}
        <button
          onClick={handleGetDirection}
          style={{
            backgroundColor: "#ffffff",
            border: "1px solid #ddd",
            padding: "18px 38px",
            minWidth: "180px",
            fontSize: "14px",
            fontFamily: "Figtree, sans-serif",
            fontWeight: "400",
            letterSpacing: "2.5px",
            textTransform: "uppercase",
            cursor: "pointer",
            borderRadius: "999px",
            transition: "all 0.3s ease",
            color: "#000",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#000";
            e.target.style.color = "#fff";
            e.target.style.borderColor = "#000";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "#fff";
            e.target.style.color = "#000";
            e.target.style.borderColor = "#ddd";
          }}
        >
          Get Direction
        </button>
      </div>
    </section>
  );
};

export default StoreLocationMap;